import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProviderData } from "../types";


export const fetchProviders = async () => {
  return apiClient<ApiResponse<ProviderData[]>>('/v1/providers', {
    method: "GET"
  });
}